import script from "./RunResidual.vue?vue&type=script&setup=true&lang=ts"
export * from "./RunResidual.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__